export default __webpack_public_path__ + "static/media/1373.4bea50cf.png";